enum PunchhPrinterBarcodeType {
  BarcodeMap1 = 'barcode-map-1',
  BarcodeMap1Short = 'barcode-map-1-short',
  BarcodeMap2 = 'barcode-map-2',
  BarcodeMap3 = 'barcode-map-3',
  QR = 'qr',
  None = 'none',
}

export { PunchhPrinterBarcodeType };
